import { cn } from '@costar-ui/cosmos'
import React from 'react'

import { useTableContext } from './table-context-provider'
import type { HeaderRowProps } from './types'
import { useIsMobileView } from '../../hooks'

const HeaderRow = React.forwardRef<HTMLTableRowElement, HeaderRowProps>(
  ({ className, ...props }, ref) => {
    const { stickyHeader } = useTableContext()
    const isMobile = useIsMobileView()
    return (
      <tr
        ref={ref}
        className={cn(
          'csg-tw-table-header-row',
          {
            'sticky z-20': stickyHeader
          },
          {
            'h-10': !isMobile
          },
          className
        )}
        {...props}
      />
    )
  }
)

HeaderRow.displayName = 'HeaderRow'

export default HeaderRow
